module.exports = __webpack_public_path__ + "img/mall.be5030ca.webp";